import { useEffect, useId, useState } from 'react';
import type { Finding } from '../../types/api';
import { Button } from '../ui/Button';
import { Dialog } from '../ui/Dialog';

export function DismissDialog({
  finding,
  onClose,
  onConfirm,
  busy,
}: {
  finding: Finding | null;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  busy?: boolean;
}) {
  const [reason, setReason] = useState('');
  const id = useId();
  useEffect(() => setReason(''), [finding?.id]);

  return (
    <Dialog
      open={!!finding}
      onClose={onClose}
      title="Dismiss finding"
      description={finding ? `“${finding.title}” will be hidden from active findings and cannot be published.` : undefined}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" loading={busy} onClick={() => onConfirm(reason.trim())}>
            Dismiss finding
          </Button>
        </>
      }
    >
      <label htmlFor={id} className="block text-sm font-medium">
        Reason <span className="font-normal text-faint">(optional)</span>
      </label>
      <textarea
        id={id}
        rows={3}
        maxLength={500}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="e.g. False positive — input is validated by middleware."
        className="input mt-1.5"
      />
    </Dialog>
  );
}
